import { handleActions } from 'redux-actions';
import { createLoadListReducer, createLoadParameterReducer } from '../../utils/getCrudConfig';
import { DASHBOARD_MODULE } from '../../configs/moduleNames';
import {
  LOAD_LIST_CAMERA, LOAD_LIST_PARKING_METER, LOAD_STAT_CAMERA, LOAD_STAT_PARKING_METER,
} from './actions';
import ListType from '../../dto/converters/ListType';
import HostProblemDTO from '../../dto/HostProblemDTO';

const initialState = {
  loadingStatParkingMeter: false,
  statParkingMeter: {},

  loadingStatCamera: false,
  statCamera: {},

  loadingListParkingMeter: false,
  listParkingMeter: [],
  listParkingMeterMeta: {},

  loadingListCamera: false,
  listCamera: [],
};

const reducer = handleActions({
  ...createLoadParameterReducer(DASHBOARD_MODULE + LOAD_STAT_PARKING_METER, 'statParkingMeter', 'loadingStatParkingMeter', {}),
  ...createLoadParameterReducer(DASHBOARD_MODULE + LOAD_STAT_CAMERA, 'statCamera', 'loadingStatCamera', {}),
  ...createLoadListReducer(DASHBOARD_MODULE + LOAD_LIST_PARKING_METER, 'listParkingMeter', 'loadingListParkingMeter'),
  ...createLoadListReducer(DASHBOARD_MODULE + LOAD_LIST_CAMERA, 'listCamera', 'loadingListCamera', []),
}, initialState);

export default reducer;

export const getDashboardData = state => {
  const reducerData = state[DASHBOARD_MODULE];
  const {
    loadingStatParkingMeter = false,
    statParkingMeter = {},

    loadingStatCamera = false,
    statCamera = {},

    loadingListParkingMeter = false,
    listParkingMeter: listPM = [],
    listParkingMeterMeta = {},

    loadingListCamera = false,
    listCamera: listCam = [],
    listCameraMeta = {},
  } = reducerData;
  const listParkingMeter = new ListType(HostProblemDTO)(listPM);
  const listCamera = new ListType(HostProblemDTO)(listCam);
  return {
    loadingStatParkingMeter,
    statParkingMeter,
    loadingStatCamera,
    statCamera,
    listParkingMeterMeta,
    loadingListParkingMeter,
    listParkingMeter,
    listCamera,
    loadingListCamera,
    listCameraMeta,
  };
};
